export const hoursBetweenTwoDates = (date1: Date, date2: Date) => {
  // Calculate the difference in milliseconds
  let diff = date2.getTime() - date1.getTime();

  // Convert the difference to hours, without any decimal places
  return Math.floor(diff / 3600000);
};
